import { Metadata } from '../types/apartments'
import { PathValue } from '../types/returnTypes'

interface StepPathProps {
  apartmentId: string
  userId: string
  metadata: Metadata
}

const getStepPath = ({
  apartmentId,
  userId,
  metadata: { client, information, media },
}: StepPathProps,
  forceStepZero = false): string => {
  const path = `/users/${userId}/apartments/${apartmentId}/steps`

  if (forceStepZero) return `${path}/0`

  if (information && media) {
    return `${path}/3`
  } else if (information && !media) {
    return `${path}/2`
  } else if (client) {
    return `${path}/1`
  }
  return `${path}/0`
}

interface CompleteCheckProps {
  hasMedia: PathValue<boolean>
  clickableSteps: number
  index: number
  isConfirmed?: PathValue<boolean>
  beforeLogin?: boolean
  hasInformation?: boolean
}

const stepChecks = ({ isConfirmed, hasMedia, index }: CompleteCheckProps) =>
  index === 2 ? hasMedia : true && index === 3 ? isConfirmed : true

const beforeLoginStepChecks = ({
  hasMedia,
  hasInformation,
  index
}: CompleteCheckProps) =>
  (index === 0 && hasInformation) || (index === 1 && hasMedia)

const checkIfStepComplete = (stepCompletionCheckProps: CompleteCheckProps) =>
  stepCompletionCheckProps.clickableSteps > stepCompletionCheckProps.index
    ? stepCompletionCheckProps.beforeLogin
      ? beforeLoginStepChecks(stepCompletionCheckProps)
      : stepChecks(stepCompletionCheckProps)
    : false

export { getStepPath, checkIfStepComplete }
